// ==============================
//  FREE GIFT JS
// ==============================

/*************************************
  IMAGE LOADER (STABLE + FAST VERSION)
*************************************/
async function loadGiftImage(img) {
  const handle = img.getAttribute("data-gift-image");
  if (!handle) return;

  try {
    const product = await fetch(`/products/${handle}.js`).then(r => r.json());
    if (product?.images?.length > 0) {
      let src = product.images[0];
      if (!src.startsWith("http")) src = "https:" + src;
      img.src = src;
    }
  } catch (err) {
    console.warn("Gift image load failed for:", handle);
  }
}

function refreshGiftImages() {
  const images = document.querySelectorAll(".free-gift-panel [data-gift-image]");
  images.forEach(loadGiftImage);
}

/********************************************
 WAIT UNTIL FREE GIFT PANEL EXISTS IN THE DOM
*********************************************/
function waitForGiftPanelThenLoad() {
  const panel = document.querySelector(".free-gift-panel");
  if (panel) {
    refreshGiftImages();
    return; // stop once found
  }

  // Try again shortly
  setTimeout(waitForGiftPanelThenLoad, 30);
}

// Run once on initial cart load
document.addEventListener("DOMContentLoaded", waitForGiftPanelThenLoad);

/********************************************
 WHEN DRAWER OPENS → WAIT & THEN LOAD
*********************************************/
document.addEventListener("cart:open", () => {
  waitForGiftPanelThenLoad();
});

/********************************************
 WHEN SHOPIFY RELOADS A SECTION
*********************************************/
window.addEventListener("shopify:section:load", () => {
  waitForGiftPanelThenLoad();
});

/********************************************
 WATCH FOR HTML REPLACEMENT (cart/drawer refresh)
 Only fire AFTER DOM settles
*********************************************/
let giftImageTimeout;
const giftImageObserver = new MutationObserver(() => {
  clearTimeout(giftImageTimeout);
  giftImageTimeout = setTimeout(waitForGiftPanelThenLoad, 40);
});

giftImageObserver.observe(document.body, {
  childList: true,
  subtree: true
});


/***********************
  CLICK → CHANGE FREE GIFT
************************/
document.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-free-gift-add]");
  if (!btn) return;

  const variantId = btn.getAttribute("data-free-gift-add");
  if (!variantId) return;

  // 1) Remove existing free gift (line price = 0)
  try {
    const cart = await fetch("/cart.js").then(r => r.json());

    for (const item of cart.items) {
      if (item.final_line_price === 0) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        break;
      }
    }
  } catch (err) {
    console.error("Error removing existing gift:", err);
  }

  // 2) Add new free gift
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });
  } catch (err) {
    console.error("Error adding new gift:", err);
  }

  // 3) Re-render UI (drawer + cart page + bubble)
  await updateCartSections();
});

/***********************
  RE-RENDER SECTIONS
************************/
async function updateCartSections() {
  try {
    const cartBase = "/cart";

    const sectionsToRender = [
      "cart-drawer",
      "cart-items",
      "main-cart-items",
      "cart-icon-bubble"
    ];

    const response = await fetch(
      `${cartBase}?sections=${sectionsToRender.join(",")}`
    );

    const data = await response.json();

    /***** DRAWER *****/
    if (data["cart-drawer"]) {
      const tempDrawer = document.createElement("div");
      tempDrawer.innerHTML = data["cart-drawer"];

      const newDrawerItems = tempDrawer.querySelector("#CartDrawer-CartItems");
      const oldDrawerItems = document.querySelector("#CartDrawer-CartItems");

      if (newDrawerItems && oldDrawerItems) {
        oldDrawerItems.innerHTML = newDrawerItems.innerHTML;
      }

      const newDrawerFooter = tempDrawer.querySelector(".drawer__footer");
      const oldDrawerFooter = document.querySelector("#CartDrawer .drawer__footer");
      if (newDrawerFooter && oldDrawerFooter) {
        oldDrawerFooter.innerHTML = newDrawerFooter.innerHTML;
      }
    }

    /***** CART PAGE *****/
    const cartHtml = data["cart-items"] || data["main-cart-items"];
    if (cartHtml) {
      const tempCart = document.createElement("div");
      tempCart.innerHTML = cartHtml;

      const newCartItems = tempCart.querySelector(".cart__items");
      const oldCartItems = document.querySelector(".cart__items");

      if (newCartItems && oldCartItems) {
        oldCartItems.innerHTML = newCartItems.innerHTML;
      }
    }

    /***** CART ICON BUBBLE *****/
    if (data["cart-icon-bubble"]) {
      const bubble = document.querySelector(".cart-count-bubble");
      if (bubble) {
        bubble.innerHTML = data["cart-icon-bubble"];
      }
    }

    refreshGiftImages();
  } catch (err) {
    console.error("Section update failed:", err);
  }
}
